import React, { useEffect, useState } from "react";
import styles from "./ProductDisplay.module.scss";
import * as ProductApi from "@src/api/ProductApi";
import { useToast } from "@swordsweeper/ssi-ui-component-library";
import ProductImage from "@src/components/widgets/ProductImage";

interface ProductDisplayProps {
  productId: string;
}

export default function ProductDisplay({ productId }: ProductDisplayProps) {
  const { showToast } = useToast();
  const [isLoadingProduct, setIsLoadingProduct] = useState(false);
  const [productData, setProductData] = useState(null);

  useEffect(() => {
    if (!!productId) {
      handleLoadProduct();
    }
  }, [productId]);

  const handleLoadProduct = async () => {
    setIsLoadingProduct(true);
    try {
      const response = await ProductApi.getProductDisplay(productId);
      setProductData(response.body);
    } catch (e) {
      console.error(e);
      showToast({
        message: "Error loading product",
        variant: "error",
      });
    } finally {
      setIsLoadingProduct(false);
    }
  };

  if (isLoadingProduct) {
    return "Loading...";
  }

  return (
    <span className={styles.root}>
      {productData?.itemName}{" "}
      {productData?.thumbnailUrl && (
        <ProductImage
          className="display-inline"
          imageSrc={productData.thumbnailUrl}
          sizePx={64}
        />
      )}
    </span>
  );
}
